<template>
  <vxe-modal v-model="visible" :title="$t('col.container')" type="confirm" width="60%" @confirm="confirm">
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.no" placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['containerType.id']" :options="containerTypes" placeholder="business.label.containerType" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :loading="loading"
        :min-height="500"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="no" title="business.label.no"/>
        <vxe-column field="name" title="business.label.name"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="operationType" title="business.label.operationType"/>
        <vxe-column field="taskId" title="business.label.taskId"/>
        <vxe-column field="currentPosition.no" title="business.label.currentPosition"/>
        <vxe-column field="lastPosition.no" title="business.label.lastPosition"/>
        <vxe-column field="destination.no" title="business.label.destination"/>
        <vxe-column field="carrier.no" title="business.label.carrier"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="physical" title="business.label.physical" width="70"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>
<script>
import { findAll } from '@/api/Api'
import { getEnums, getOptions } from '@/utils/util'

export default {
  name: 'ContainerModal',
  props: {
    selectType: { type: String, default: 'radio' }
  },
  data() {
    return {
      show: true,
      visible: false,
      loading: false,
      data: [],
      operationTypes: [],
      containerTypes: [],
      query: {
        'no': '',
        'containerType.id': ''
      },
      args: null,
      record: undefined,
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  created() {
    this.loading = true
    findAll('containerTypeFactory', { available: true }).then(res => {
      if (res.success) {
        this.containerTypes = getOptions(res.result)
      }
      return getEnums('OperationType')
    }).then(result => {
      this.operationTypes = result
    }).finally(() => this.loading = false)
  },
  methods: {
    init(args) {
      this.query = {
        'no': '',
        'containerType.id': ''
      }
      this.data = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e) {
      this.init(args)
      this.record = e
      this.visible = true
      this.refresh()
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('containerFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'no': '',
        'containerType.id': ''
      }
      Object.assign(this.query, this.args)
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        selectedRows = this.$refs.table.getCheckboxRecords()
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    }
  }
}
</script>